// navigation events precede the request; the selected tab still belongs to the server.
let pendingLink;
let recoveryTimer;
let navigation = 0;

function clearPending() {
    navigation++;
    clearTimeout(recoveryTimer);
    pendingLink?.removeAttribute('aria-busy');
    pendingLink = null;
    const status = document.querySelector('[data-nx-navigation-status]');
    if (status) status.textContent = '';
}

document.addEventListener('livewire:navigate', event => {
    clearPending();
    const generation = navigation;
    const destination = event.detail?.url?.href;
    const link = [...document.querySelectorAll('.nx-bottom-nav a[wire\\:navigate]')].find(
        link => link.href === destination
    );

    // wait for other listeners to veto navigation (unsaved changes, for example).
    queueMicrotask(() => {
        if (generation !== navigation || event.defaultPrevented || !link?.isConnected) return;
        clearPending();
        pendingLink = link;
        link.setAttribute('aria-busy', 'true');
        const status = document.querySelector('[data-nx-navigation-status]');
        if (status) status.textContent = `${status.dataset.loadingLabel}: ${link.textContent.trim()}`;

        // Livewire does not emit a public navigation-failed event. Allow retry after
        // a stalled/failed request without leaving a permanent busy indication.
        recoveryTimer = setTimeout(clearPending, 10000);
    });
});

document.addEventListener('livewire:navigated', clearPending);
window.addEventListener('pageshow', clearPending);
window.addEventListener('offline', clearPending);
